var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('v-container',{staticClass:"charttitle"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }